import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useAccDistAssigned = (page, pageSize, selectedStatus, filters, searchName) => {
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalAccounts, setTotalAccounts] = useState(0);
    const [accountStatusCount, setAccountStatusCount] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [absoluteTotal, setAbsoluteTotal] = useState(0);
    const [refreshKey, setRefreshKey] = useState(0); // Add refresh trigger

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const AccountStatus = [];
            const queryParams = new URLSearchParams({
                page: page.toString(),
                page_size: pageSize.toString()
            });

            if(selectedStatus) {
                AccountStatus.push(selectedStatus);
            }
            if (filters?.leadStatus?.length) {
                AccountStatus.push(...filters.churnlikelihood);
            }
            AccountStatus.forEach(status => {
                queryParams.append("churn_profile", status);
            });
            if (filters?.churnlikelihood?.length) {
                filters.churnlikelihood.forEach(product => {
                    queryParams.append("churn_profile", product);
                });
            }
            // Handle name search
            if(searchName){
                queryParams.append("name", searchName);
                console.log(queryParams);
            }
            // Handle product selection
            if (filters?.products?.length) {
                filters.products.forEach(product => {
                    queryParams.append("products", product);
                });
            }
            // Handle relationship selection
            if (filters?.relationship?.length) {
                filters.relationship.forEach(product => {
                    queryParams.append("relationship", product);
                });
            }
            // Handle lead source selection
            if (filters?.profilename?.length) {
                filters.profilename.forEach(source => {
                    queryParams.append("profile_name", source);
                });
            }
            
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_ACCOUNTS.ALL_INVENTORY}?status=5&${queryParams.toString()}`, 'GET')
            // Assign data to state
            setData(result.data);
            setTotalPages(result.total_pages);
            setTotalAccounts(result.total_rows);
            setAccountStatusCount(result.account_churn_counts);
            setAbsoluteTotal(result.absolute_total);
            
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [page, pageSize, selectedStatus, filters, searchName, refreshKey]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Expose refresh function
    const refresh = useCallback(() => {
        setRefreshKey(prev => prev + 1);
    }, []);

    return { 
        data, 
        totalPages, 
        totalAccounts, 
        accountStatusCount, 
        isLoading, 
        absoluteTotal,
        refresh // Add refresh function to return
    };
};